import { lazy } from 'react';

import type { RouteConfig } from '../../types';

const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));
const HierarchyVersionLayout = lazy(() => import('@/pages/hierarchy/[versionId]/layout'));
const HierarchyVersionPage = lazy(() => import('@/pages/hierarchy/[versionId]'));

/**
 * Hierarchy is only accessible via `/hierarchy/:versionId` — entry point is the
 * "Hierarchy" card on `/structureVersions/:versionId`. The plain `/hierarchy`
 * URL is intentionally absent.
 */
export const hierarchyRoutes: RouteConfig = {
  path: '/hierarchy',
  layout: DashboardLayout,
  children: [
    {
      path: '/:versionId',
      layout: HierarchyVersionLayout,
      element: HierarchyVersionPage,
    },
  ],
};
